module.exports = __webpack_public_path__ + "img/tktz.2dc0ebaa.png";